exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ms-ContextualMenu-icon ._2QKC1FC0iB3iR4DOxwVSRM{position:relative;top:-8px}", ""]);
// Exports
exports.locals = {
	"fallbackIcon": "_2QKC1FC0iB3iR4DOxwVSRM"
};